<template>
    <div>
        Trainings
    </div>
</template>

<script>
    export default {
        name: 'TrainingsView',

        setup() {

        }
    }
</script>

<style lang="scss" scoped>

</style>